import { UnitInformationFooter } from './components/UnitInformationFooter';
import '../../../../../../../scss/_rentalUnitsUnitInfoTable.scss';
import { UnitInformationTableRows } from './components/UnitInformationTableRows';
import { UnitInformationHeader } from './components/UnitInformationHeader';
import { singleStructures } from '../../../../../constants/singleStructures';

interface UnitInformationTableProps {
    propertyGuid: string;
    type: string;
    rentalUnitGuids: string[];
    includeOccupied: boolean;
    isReview?: boolean;
}

export const UnitInformationTable: React.FC<UnitInformationTableProps> = ({
    propertyGuid,
    type,
    rentalUnitGuids,
    includeOccupied,
    isReview = false,
}) => {
    return (
        <div className={`unit-info ${isReview ? 'review' : ''}`}>
            <UnitInformationHeader
                type={type}
                includeOccupied={includeOccupied}
            />

            {rentalUnitGuids?.map((unitGuid, index) => (
                <div
                    key={index}
                    className='unit-info-row'
                >
                    {!singleStructures.includes(type) && <div className='col unit'>Unit {index + 1}</div>}

                    <UnitInformationTableRows
                        unitGuid={unitGuid}
                        includeOccupied={includeOccupied}
                        isReview={isReview}
                    />
                </div>
            ))}
            <UnitInformationFooter
                propertyGuid={propertyGuid}
                type={type}
                includeOccupied={includeOccupied}
                isReview={isReview}
            />
        </div>
    );
};
